module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_tablet.79edb232.jpg";